import React from "react";
import { Provider, createDispatchHook, createSelectorHook } from "react-redux";
import { unoStore } from "../store/store";
const UnoContext = React.createContext(null);
export const useUnoDispatch = createDispatchHook(UnoContext);
export const useUnoSelector = createSelectorHook(UnoContext);

export const UnoProvider = ({ children }) => {
  return (
    <Provider context={UnoContext} store={unoStore}>
      {children}
    </Provider>
  );
};
